import { useTheme } from 'styled-components';

export const AnalysisIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.4653 3.71533H11.8358C12.0976 3.71533 12.31 3.92775 12.31 4.18955V8.25152C12.31 8.51611 12.0976 8.7276 11.8358 8.7276H10.4653C10.2007 8.7276 9.98926 8.51518 9.98926 8.25152V4.18955C9.98833 3.92774 10.2007 3.71533 10.4653 3.71533Z"
        fill={theme.iceBlue}
      />
      <path
        d="M13.1665 1.91103H14.537C14.7988 1.91103 15.0112 2.12345 15.0112 2.38525V8.25198C15.0112 8.51658 14.7988 8.72806 14.537 8.72806L13.1665 8.72899C12.9047 8.72899 12.6904 8.51657 12.6904 8.25291V2.38523C12.6904 2.12342 12.9047 1.91101 13.1665 1.91101V1.91103Z"
        fill={theme.iceBlue}
      />
      <path
        d="M15.9195 0H17.29C17.5546 0 17.7661 0.212417 17.7661 0.474218V8.2516C17.7661 8.5162 17.5537 8.72768 17.29 8.72768H15.9195C15.6577 8.72768 15.4453 8.51527 15.4453 8.2516V0.474218C15.4453 0.212412 15.6577 0 15.9195 0Z"
        fill={theme.iceBlue}
      />
      <path
        d="M15.3745 15.9088C16.9006 14.3828 17.8798 12.3136 18 10.0161H9.00767C8.74587 10.0161 8.53345 9.80367 8.53345 9.54187V0.551453C0.791366 0.952998 -2.86825 10.3981 2.64264 15.909C6.15771 19.4241 11.8596 19.4241 15.3747 15.909L15.3745 15.9088Z"
        fill={theme.iceBlue}
      />
    </svg>
  );
};
